export default __webpack_public_path__ + "static/media/air_handler.8dd6378c.png";